module.exports = __webpack_public_path__ + "img/engage-logo.5cf73f0a.png";